import { global_hooks } from 'src/globals';

function init() {
	gravityforms_interface();
}
init();

function handle_render(form_id, page) {
	const el = document.querySelector('#gform_wrapper_' + form_id);
	if (!el) return;

	global_hooks.do('gform/render', { form_id, page, el });
	global_hooks.do(`gform/render/${form_id}`, { page, el });

	global_hooks.do_queue('gform/render', { form_id, page, el });
	global_hooks.do_queue(`gform/render/${form_id}`, { page, el });

	load_dynamic_components({ form_id, page, el });
}

function gravityforms_interface() {
	// GF 2.7+ native CustomEvent (slash)
	document.addEventListener('gform/post_render', (e) => {
		handle_render(e.detail.formId, e.detail.currentPage);
	});

	// GF < 2.7 jQuery trigger (underscore) — extra args passed by jQuery
	document.addEventListener('gform_post_render', (e) => {
		const form_id = e.detail?.formId ?? e.detail?.[0];
		const page    = e.detail?.currentPage ?? e.detail?.[1] ?? 1;
		if (form_id) handle_render(form_id, page);
	});
}

function load_dynamic_components(args) {
	if (args.el.querySelector('.gfield_select')) {
		import('./dropdown_styling').then((e) => e.init(args));
	}
}
